/** Strings for the runs list and the run page (S7). */
export const runsCopy = {
  caption: {
    workspace: 'Runs in this workspace',
    agent: 'Runs for this agent',
  },
  page: {
    crumb: 'Runs',
    title: 'Runs',
    description: 'Execution history and traces',
  },
  trace: {
    title: 'Run trace',
    description: 'Execution trace and metrics',
    back: 'Back',
  },
  rowLink: (shortId: string) => `, run ${shortId}`,
  loadFailed: 'Could not load runs.',
  loadRunFailed: 'Could not load this run.',
  refreshFailed: 'Could not refresh runs.',
  loadMoreFailed: 'Could not load more runs.',
  refreshRunFailed: 'Could not refresh this run.',
  filteredEmpty: (status: string) => `No ${status} runs.`,
  clearFilter: 'Clear filter',
  retry: 'Retry',
  filterLabel: 'Status',
  allStatuses: 'All statuses',
  emptyNone: 'No runs recorded yet.',
  emptyNoWorkspace: 'No workspace selected.',
  columns: {
    status: 'Status',
    agent: 'Agent',
    llm: 'LLM',
    tools: 'Tools',
    tokens: 'Tokens',
    cost: 'Cost',
    duration: 'Duration',
    started: 'Started',
  },
  errorLine: (kind: string | null, message: string) =>
    `[${kind ?? 'error'}] ${message}`,
  steps: 'Steps',
  facts: {
    id: 'ID',
    status: 'Status',
    agent: 'Agent',
    model: 'Model',
    provider: 'Provider',
    trigger: 'Trigger',
    topic: 'Topic',
    llmCalls: 'LLM calls',
    toolCalls: 'Tool calls',
    tokens: 'Tokens',
    cost: 'Cost',
    duration: 'Duration',
  },
} as const
